import { useState } from "react";
export default function Image(rest){
    const [load, setload] = useState(false)
   
    return (<>
   
    <img {...rest}  onLoad={(e)=> setload(true)} onLoadStart={()=>setload(false)}  style={load ? { display: 'inline-block' } : { display: 'none' }}/>
    </>)
}